









import Vue from 'vue';
import UtilsService from '../services/UtilsService';

export default Vue.extend({
  props: ['value', 'mask', 'rules'],
  data() {
    return {
      text: this.value,
      newRules: this.rules && this.rules.map((r: any) => {
        return (v: any) => {
          return r(UtilsService.unmask((this as any).text, this.mask));
        };
      }) || [],
    };
  },
  watch: {
    text(val) {
      this.$emit('input', UtilsService.unmask(val, this.mask));
    },
  },
});
